import {createRouter, createWebHashHistory, RouteRecordRaw} from "vue-router";
import Init from "../views/init.vue";
import ConfigurationOverview from "../views/configurations/configurationOverview.vue";
import Workspaces from "../views/workspaces.vue";
import ItemAni from "../views/item_ani.vue";
import ItemV2PrintOut from "@/components/itemV2/itemV2PrintOut.vue";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "Init",
        component: Init,
    },
    {
        path: "/workspaces",
        name: "ConfWorkspaces",
        component: Workspaces,
    },
    {
        path: "/conf/:sessionId",
        name: "ConfigurationOverview",
        component: ConfigurationOverview,
    },
    {
        path: "/conf/:sessionId/:itemIdx",
        name: "ConfigurationItem",
        component: ConfigurationOverview,
    },
    {
        path: "/conf/:sessionId/printout",
        name: "ConfigurationPrintout",
        component: ItemV2PrintOut,
    },
    {
        path: "/ani",
        name: "ani",
        component: ItemAni,
    },
];

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes,
});

export default router;
